import { useImmer } from "use-immer";
import { useEffect } from "react";
import DayOfWeekCheckboxes from "../DayOfWeekCheckboxes";

const CustomerHistoryConfigComponent = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <article>
      <table className="config-table">
        <thead>
        <tr>
          <th>Attribute</th>
          <th>Value</th>
        </tr>
        </thead>

        <tbody>
        <tr>
          <td>Update on days</td>
          <td>
            <DayOfWeekCheckboxes
              dayOfWeekArray={data.updateAtDays}
              onChange={(e) =>
                updateData((d) => {
                  d.updateAtDays = e;
                })
              }
            />
          </td>
        </tr>

        <tr>
          <td>Update at time [CET]</td>
          <td>
            <input
              type="time"
              value={data.updateAtTime}
              onChange={(e) =>
                updateData((d) => {
                  d.updateAtTime = e.target.value;
                })
              }
            />
          </td>
        </tr>

        <tr>
          <td>History start lookup [days]</td>
          <td>
            <input
              type="number"
              value={data.startSkipDays}
              onChange={(e) =>
                updateData((d) => {
                  d.startSkipDays =
                    e.target.value >= 0 ? e.target.value : 0;
                })
              }
            />
          </td>
        </tr>

        <tr>
          <td>Slot size [days]</td>
          <td>
            <input
              type="number"
              value={data.slotSizeDays}
              onChange={(e) =>
                updateData((d) => {
                  d.slotSizeDays =
                    e.target.value > 0 ? e.target.value : 1;
                })
              }
            />
          </td>
        </tr>

        <tr>
          <td>Visit merge [minutes]</td>
          <td>
            <input
              type="number"
              value={data.visitMergeMinutes}
              onChange={(e) =>
                updateData((d) => {
                  d.visitMergeMinutes =
                    e.target.value >= 0 ? e.target.value : 0;
                })
              }
            />
          </td>
        </tr>

        <tr>
          <td>Total slots</td>
          <td>
            <input
              type="number"
              value={data.totalSlots}
              onChange={(e) =>
                updateData((d) => {
                  d.totalSlots =
                    e.target.value >= 0 ? e.target.value : 0;
                })
              }
            />
          </td>
        </tr>
        </tbody>
      </table>
    </article>
  );
};

export default CustomerHistoryConfigComponent;
